<template>
    <div class="lifecircle-container" >
        <div class="lifecircle-container-body">
            <div class="lifecircle-video-body">
                <video 
                id="video"
                ref="video"
                class="video" 
                @click="onVideoPause"
                @timeupdate="ontimeupdate"
                @canplay="oncanplay"
                @ended="onended"
                webkit-playsinline="true"
                playsinline="true"
                x-webkit-airplay="allow"
                :src="detail_data.video_url"
                :poster="detail_data.poster"
                x5-playsinline
                >
                </video>
                <!-- <canvas class="video" id="canvas"></canvas> -->
                <div v-show="pause" class="video-bofang" @click="onVideoPause">
                    <img :src="bofang_pic" alt="">
                </div>
                <div class="lifecircle-video-content">
                    <div class="lifecircle-head">
                        <img :src="detail_data.avatar || default_pic" alt="">
                        <div class="lifecircle-head-name">{{detail_data.nickname}}</div>
                        <div class="lifecircle-head-follow">
                            <van-button color="linear-gradient(to right, #ff7641, #ff0b40)">
                                <span class="follow">关注</span>
                            </van-button>
                            <wxopenbtn type="life_circle_video_detail" :postid="detail_data.post_id" />
                        </div>
                    </div>
                    <div v-show="!more_show" class="content">
                        <span class="content-text">{{detail_data.title}}</span><span v-show="!more_show" class="content-morebtn" @click="showMorebtn">显示全文</span>
                    </div>
                    <div v-show="more_show" class="content-show-title">{{detail_data.title}}</div>
                    <div v-show="more_show" class="content-body">{{detail_data.content}}</div>
                    <div v-show="more_show" class="content-datetime">
                        <span class="content-datetime-text">{{formatTime(detail_data.release_time)}}</span>
                        <span class="content-morebtn" @click="showMorebtn">收起</span>
                    </div>
                    <div class="video-progress">
                        <van-progress :percentage="percentage" stroke-width="1" color="#666666" track-color="#333333" :show-pivot="false" />
                    </div>
                </div>
            </div>
            <div ref="aaaa" class="lifecircle-waterlist">
                <div class="line"></div>
                <waterlist type="life_circle_video_detail" :postid="detail_data.post_id" />
            </div>
        </div>
        <openapp type="life_circle_video_detail" :postid="detail_data.post_id" />
        <van-overlay :show="request_err" @click="request_err = false">
            <div class="overlay-wrapper" @click.stop>
                <img :src="load_err_png" alt="">
                <div class="overlay-error-text">请求失败</div>
                <div class="overlay-btn">
                    <van-button @click="reRequest" color="linear-gradient(to right, #ff7641, #ff0b40)">
                        <span class="follow">重新请求</span>
                    </van-button>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
    import waterlist from "./water-list.vue";
    import openapp from "./open-app.vue";
    import { Toast } from 'vant';
    import wxopenbtn from "./wxopenbtn.vue";
    const u = navigator.userAgent;
    // let canvas = null;
    // let videos = null;
    // let context =null;
    
    export default {
        components: {
            waterlist,
            openapp,
            wxopenbtn
        },
        data() {
            return {
                load_err_png: require("@/assets/lifecircle/load_err.png"),
                bofang_pic: require("@/assets/lifecircle/bo-fang.png"),
                logofill_pic: require("@/assets/lifecircle/logo-fill.png"),
                default_pic: require("@/assets/lifecircle/default.png"),
                pause: true,
                percentage: 0,
                duration: 0,
                more_show: false,
                request_err: false,
                detail_data: {}
            }
        },
        methods: {
            onVideoPause(){
                if (this.pause) {
                    this.pause = false;
                    this.$refs.video.play();
                    // this.switchToCanvas();
                }else{
                    this.pause = true;
                    this.$refs.video.pause();
                }
            },
            oncanplay(e){
                this.duration = this.$refs.video.duration;;
            },
            onended(){
                this.pause = true;
            },
            // switchToCanvas() {
            //     // 将video上的图片的每一帧以图片的形式绘制的canvas上
            //     context.drawImage(videos, 0, 0, canvas.width, canvas.height);

            //     window.requestAnimationFrame(this.switchToCanvas);
            // },
            ontimeupdate(){
                this.percentage = Math.floor((this.$refs.video.currentTime / this.duration)*100);
            },
            showMorebtn(){
                this.more_show = !this.more_show;
            },
            formatTime(time) {
                return String(time).split(" ")[0].replace(/-/g, "/");
            },
            getDetailFn(){
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$api.post("/life-moments/index/dynamic/detail",{post_id: this.$route.query.post_id || ""}).then((res) => {
                    this.detail_data = {
                        post_id: res._id,
                        avatar: res.avatar,
                        content: res.content,
                        nickname: res.nickname,
                        release_time: res.release_time,
                        title: res.title,
                        video_url: res.img_video[0].completeUrl,
                        poster: res.img_video[0].thumbnail
                    }
                    Toast.clear();
                    this.request_err = false;
                }).catch((err) => {
                    Toast.clear();
                    this.request_err = true;
                    if (err.response.data.data && err.response.data.data.post_id) {
                        Toast(err.response.data.data.post_id[0])
                    }else{
                        Toast("获取数据失败")
                    }
                });
            },
            reRequest(){
                this.getDetailFn();
            },
            blurHandle(){
                if (!this.pause) {
                    this.pause = true;
                    this.$refs.video.pause();
                }
            },
            scrollHandle(){
                if (document.documentElement.scrollTop >= 640) {
                    if (!this.pause) {
                        this.pause = true;
                        this.$refs.video.pause();
                    }
                }
            },
            wxConfig(){
                this.$api.post("member/index/wechat/get/sign/package",{
                    type: 2,
                    url: location.href
                }).then((res) => {
                    wx.config({
                        debug: false,
                        appId: res.appId,
                        nonceStr: res.nonceStr,
                        signature: res.signature,
                        timestamp: res.timestamp,
                        jsApiList: ["checkJsApi"],
                        openTagList: ["wx-open-launch-app"],
                    });
                }).catch((err) => {
                    
                });
            }
        },
        created() {
            if (u.toLowerCase().includes("micromessenger")) {
                this.wxConfig();
            }
            this.getDetailFn();
        },
        mounted() {
            // canvas = document.getElementById("canvas");
            // videos = document.getElementById("video");
            // context = canvas.getContext("2d");
            window.addEventListener("blur", this.blurHandle);
            document.addEventListener("scroll", this.scrollHandle);
        },
        beforeDestroy() {
            window.removeEventListener("blur", this.blurHandle);
            document.addEventListener("scroll", this.scrollHandle);
        },
    }
</script>

<style lang="less" scoped>
    .lifecircle-container{
        padding-bottom: 50px;
        background-color: #ffffff;
        .lifecircle-container-body{
            flex: 1;
            overflow-y: auto;
            .lifecircle-waterlist{
                padding: 0 15px;
            }
            .line{
                margin: 40px 0;
                height: 1px;
                background-color: rgba(0,0,0,0.05);
            }
            .video{
                width: 100%;
                height: 640px;
            }
        }
        .lifecircle-video-body{
            position: relative;
            height: 640px;
            background-color: #000000;
            .video-bofang{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 58px;
                height: 58px;
                margin-left: -29px;
                margin-top: -29px;
                img{
                    width: 58px;
                    height: 58px;
                }
            }
            .lifecircle-video-content{
                box-sizing: border-box;
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                // height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                .lifecircle-head{
                    display: flex;
                    align-items: center;
                    height: 65px;
                    padding: 0 15px;
                    img{
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                    }
                    .lifecircle-head-name{
                        flex: 1;
                        margin-left: 10px;
                        font-size: 16px;
                        font-family: PingFangSC, PingFangSC-Medium;
                        font-weight: 500;
                        color: #CCCCCC;
                    }
                    .lifecircle-head-follow{
                        position: relative;
                        width: 57px;
                        height: 30px;
                        border-radius: 22px;
                        overflow: hidden;
                        .follow{
                            color: #ffffff;
                        }
                        .no-follow{
                            color: rgba(0,0,0,0.40);
                        }
                        &/deep/.van-button{
                            width: 57px;
                            height: 30px;
                            padding: 0;
                        }
                    }
                }
                .content{
                    height: 20px;
                    padding: 0 15px;
                    line-height: 20px;
                    color: #CCCCCC;
                    display: flex;
                    .content-text{
                        flex: 1;
                        font-size: 14px;
                        line-clamp: 1;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                    
                }
                .content-show-title{
                    padding: 0 15px;
                    font-size: 14px;
                    line-height: 20px;
                    color: #CCCCCC;
                }
                .content-morebtn{
                    color: #6186C4;
                    font-size: 12px;
                    font-family: PingFangSC, PingFangSC-Regular;
                }
                .content-body{
                    font-size: 14px;
                    margin-top: 5px;
                    padding: 0 15px;
                    color: #CCCCCC;
                }
                .content-datetime{
                    display: flex;
                    justify-content: space-between;
                    padding: 0 15px;
                    margin-top: 8px;
                    .content-datetime-text{
                        color: #CCCCCC;
                    }
                }
                .video-progress{
                    padding: 15px 0;
                }
            }
        }
        .overlay-wrapper{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            background-color: #000000;
            .overlay-error-text{
                margin-top: 8px;
                color: #F84438;
                font-size: 12px;
                font-family: PingFangSC, PingFangSC-Regular;
            }
            img{
                width: 179px;
                height: 100px;
            }
            .overlay-btn{
                margin-top: 24px;
                width: 76px;
                height: 30px;
                border-radius: 22px;
                overflow: hidden;
                &/deep/.van-button{
                    width: 76px;
                    height: 30px;
                    padding: 0;
                }
            }
        }
    }
    
</style>